/**
 * Note: shortcuts with a combination of keys ending in the same key (e.g. 'g+p' and 'n+p')
 * will both be triggered at the same time because the library stores them both under 'p'.
 * If you want to them to work, make them sequences instead (i.e. 'g p' and 'n p')
 * @see https://github.com/ccampbell/mousetrap/issues/101
 *
 * Convention: If there are two shortcuts, the first one in the array is mac, the second one windows.
 */
export default {
  help: '?',
  search: '/',
  cancel: 'esc',
  confirm: 'enter',
  delete: 'del',

  'commands:toggle': 'o p',

  'go:projects': 'g p',
  'go:sources': 'g d',
  'go:quotations': 'g q',
  'go:views': 'g v',
  'go:codes': 'g c',
  'go:memos': 'g m',
  'go:settings': 'g s',

  'go:codeGroups': 'g g c',
  'go:memoGroups': 'g g m',
  'go:sourceGroups': 'g g s',

  'go:back': 'b b',
  'go:forward': 'f f',

  'create:project': 'n p',
  'create:source': 'n d',
  'create:code': 'n c',
  'create:memo': 'n m',

  'invite:member': 'i m',

  'editor:bold': ['command+b', 'ctrl+b'],
  'editor:underline': ['command+u', 'ctrl+u'],
  'editor:italic': ['command+i', 'ctrl+i'],
  'editor:headline1': ['command+alt+1', 'ctrl+alt+1'],
  'editor:headline2': ['command+alt+2', 'ctrl+alt+2'],
  'editor:headline3': ['command+alt+3', 'ctrl+alt+3'],
  'editor:ol': ['command+shift+7', 'ctrl+shift+7'],
  'editor:ul': ['command+shift+8', 'ctrl+shift+8'],

  'submit-main': ['command+enter', 'shift+enter'],

  'submit-extra': 'ctrl+enter',

  konami: 'up up down down left right left right b a enter',

  'global-search:open': ['command+k', 'ctrl+k'],
};
